/**
 * 1.3.1 the portal app (Q1): the supplier's text for a refused upload (507 PORTAL_QUOTA, details PortalQuotaRefusal):
 * quota.month or quota.pending with the used bytes and the limit. errorText (client.ts) asks it first. Q1's file.
 */
import type { PortalQuotaRefusal } from '@prism/contracts';
import type { PortalApiError } from '../client';
import { formatBytes } from '../format';
import { t } from '../i18n/en';

/** The quota text for an error, or null when it is not a quota refusal (errorText then uses the catalogue). */
export function quotaErrorText(err: PortalApiError): string | null {
  if (err.code !== 'PORTAL_QUOTA') return null;
  const d = (err.details ?? {}) as Partial<PortalQuotaRefusal>;
  if ((d.which !== 'month' && d.which !== 'pending') || typeof d.usedBytes !== 'number' || typeof d.limitBytes !== 'number') {
    // Without the details the server's own message says the same.
    return err.message || null;
  }
  return t(`quota.${d.which}`, { used: formatBytes(d.usedBytes), limit: formatBytes(d.limitBytes) });
}
